import React, { useEffect, useState } from "react";
import { loadStyles } from "../../utils/cssLoader";
import Racecourse from "./Racecourse";

const HorseRacingCard = ({
    data,
    dataClient,
    loadCSS
}) => {
    const [clientData, setClientData] = useState([]);

    useEffect(() => {
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;

        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || []);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [dataClient]);

    useEffect(() => {
        if (loadCSS === "true") {
            loadStyles("horse");
        }
    }, [loadCSS]);


    const finalData = dataClient ? clientData : data;
    const safeRaceData = {
        ...finalData?.data,
        runner: Array.isArray(finalData?.data?.runner) ? finalData?.data?.runner : [],
    };
    return (
        <Racecourse raceData={safeRaceData} />
    );
};

export default HorseRacingCard;
